export interface Movie {
  id: string;
  title: string;
  cover: string;
  hero?: string;
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  duration: string;
  language: string;
  rating: number;
  popularity: number;
  tags: string[];
  featured?: boolean;
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: "chunfen-zhihou",
    title: "春分之后",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%2C%20a%20young%20woman%20gazing%20out%20a%20rainy%20window%20in%20soft%20warm%20light%2C%20peach%20pink%20and%20amber%20tone%2C%20moody%20artistic%20portrait%2C%20film%20grain%2C%20minimal%20elegant%20composition%2C%20vertical%20poster%20art&width=600&height=900&seq=movie-poster-01&orientation=portrait",
    hero: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20backdrop%20of%20a%20quiet%20spring%20town%20after%20rain%2C%20soft%20peach%20and%20amber%20light%2C%20lonely%20figure%20walking%20on%20wet%20street%2C%20moody%20film%20still%2C%20atmospheric%20fog%2C%20warm%20cinematic%20grading%2C%20no%20text&width=1600&height=900&seq=movie-hero-01&orientation=landscape",
    year: 2023,
    region: "大陆",
    genres: ["爱情", "剧情"],
    director: "周慕白",
    cast: ["林砚", "苏晓棠", "陈知遥"],
    duration: "118分钟",
    language: "普通话",
    rating: 8.4,
    popularity: 96,
    tags: ["治愈", "文艺", "高口碑"],
    featured: true,
    synopsis:
      "春分那天，回到故乡小城的建筑师顾清遇见了十年未见的旧友。两人在潮湿的街道与熟悉的巷口之间，重新拾起被时间冲淡的记忆。影片以克制的镜头语言，讲述一段关于告别、和解与重新开始的温柔故事。",
  },
  {
    id: "yexing-lieche",
    title: "夜行列车",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%2C%20silhouette%20of%20a%20man%20on%20a%20night%20train%20corridor%2C%20deep%20blue%20gray%20tone%20with%20orange%20lamp%20glow%2C%20tense%20thriller%20mood%2C%20film%20noir%20lighting%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-02&orientation=portrait",
    year: 2022,
    region: "欧美",
    genres: ["悬疑", "剧情"],
    director: "Elias Moreau",
    cast: ["Jonah Reid", "Mara Vance", "Leo Grant"],
    duration: "126分钟",
    language: "英语",
    rating: 8.1,
    popularity: 88,
    tags: ["烧脑", "悬疑", "经典"],
    synopsis:
      "一趟横穿雪原的夜行列车，九位素不相识的乘客。当列车在中途无声停靠，一场谁也无法下车的心智博弈就此展开。真相被层层反转包裹，直到终点站前最后一刻才被揭晓。",
  },
  {
    id: "juzi-qishui",
    title: "橘子汽水",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%2C%20two%20teenagers%20on%20bicycles%20at%20golden%20sunset%2C%20bright%20orange%20and%20peach%20sky%2C%20nostalgic%20summer%20youth%20story%2C%20warm%20sunlit%20film%20still%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-03&orientation=portrait",
    year: 2024,
    region: "大陆",
    genres: ["爱情", "青春"],
    director: "许知夏",
    cast: ["陆叙", "姜念", "何舟"],
    duration: "104分钟",
    language: "普通话",
    rating: 8.6,
    popularity: 94,
    tags: ["青春", "治愈", "热映"],
    featured: true,
    synopsis:
      "高考结束的那个暑假，小镇汽水摊的两个少年约定要一起去看海。一瓶橘子汽水，一段没有说出口的心事，被永远留在了那个滚烫的夏天。这是一封写给所有人的青春情书。",
  },
  {
    id: "shenhai-huisheng",
    title: "深海回声",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20deep%20ocean%20trench%20with%20glowing%20teal%20lights%20and%20a%20lone%20submersible%2C%20dark%20atmospheric%20underwater%20scene%2C%20mysterious%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-04&orientation=portrait",
    year: 2023,
    region: "欧美",
    genres: ["科幻", "悬疑"],
    director: "Nadia Petrova",
    cast: ["Reed Salvatore", "Ivy Chen", "Tomas Karr"],
    duration: "134分钟",
    language: "英语",
    rating: 8.3,
    popularity: 91,
    tags: ["科幻", "视觉奇观", "烧脑"],
    synopsis:
      "一支深海勘探队在六千米海沟深处捕捉到一段不该存在的声音信号。随着调查深入，队员们发现那道回声远比海洋本身更加古老，也更加危险。一部关于人类渺小与宇宙浩瀚的科幻寓言。",
  },
  {
    id: "wanfeng-xinxiang",
    title: "晚风信箱",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20movie%20poster%2C%20a%20vintage%20red%20mailbox%20on%20a%20quiet%20street%20at%20dusk%2C%20warm%20peach%20and%20rose%20tone%2C%20soft%20dreamy%20lighting%2C%20sentimental%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-05&orientation=portrait",
    year: 2021,
    region: "港台",
    genres: ["爱情", "文艺"],
    director: "陈以安",
    cast: ["何芷晴", "方书禾", "张国轩"],
    duration: "110分钟",
    language: "粤语",
    rating: 8.0,
    popularity: 79,
    tags: ["文艺", "爱情", "治愈"],
    synopsis:
      "旧城改造前夕，一间即将拆除的老式信箱里，被塞进了最后一封没有寄出的信。整理信件的女孩循着信中地址，走进了一段跨越二十年的牵绊。一封封信，拼凑出两个人错过的整个青春。",
  },
  {
    id: "zhuiguangzhe",
    title: "追光者",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%2C%20a%20man%20running%20through%20neon%20lit%20city%20streets%20at%20night%2C%20dynamic%20motion%2C%20orange%20and%20dark%20gray%20tone%2C%20intense%20urban%20thriller%20energy%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-06&orientation=portrait",
    year: 2024,
    region: "大陆",
    genres: ["动作", "剧情"],
    director: "韩牧",
    cast: ["沈越", "田宁", "赵一鸣"],
    duration: "128分钟",
    language: "普通话",
    rating: 8.2,
    popularity: 93,
    tags: ["动作", "热血", "热映"],
    featured: true,
    synopsis:
      "曾经的城市短跑冠军，如今以送外卖为生。当昔日队友陷入一场无法抽身的麻烦，他不得不重新站上跑道，用双腿丈量这座城市的明与暗。速度既是他的天赋，也是他最后的武器。",
  },
  {
    id: "liuyue-moli",
    title: "六月茉莉",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20arthouse%20movie%20poster%2C%20white%20jasmine%20flowers%20and%20an%20old%20teahouse%20window%2C%20soft%20cream%20and%20green%20tone%2C%20quiet%20nostalgic%20mood%2C%20film%20grain%20texture%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-07&orientation=portrait",
    year: 2020,
    region: "港台",
    genres: ["文艺", "剧情"],
    director: "林清和",
    cast: ["苏若兰", "郑文泰"],
    duration: "116分钟",
    language: "闽南语",
    rating: 7.9,
    popularity: 68,
    tags: ["文艺", "慢节奏", "人文"],
    synopsis:
      "南国小镇的一间老茶铺，守着一门即将失传的手艺，也守着一家人的聚散离合。随着最后一批茉莉花谢，过去那些无法言说的遗憾终于有了被听见的机会。",
  },
  {
    id: "xinghe-lvguan",
    title: "星河旅馆",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20romance%20movie%20poster%2C%20a%20cozy%20hotel%20floating%20among%20stars%20and%20nebulae%2C%20warm%20amber%20windows%20against%20deep%20space%2C%20dreamy%20surreal%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-08&orientation=portrait",
    year: 2023,
    region: "日韩",
    genres: ["科幻", "爱情"],
    director: "佐藤绫",
    cast: ["中村凛", "朴允儿", "高桥彻"],
    duration: "122分钟",
    language: "日语",
    rating: 8.5,
    popularity: 90,
    tags: ["科幻", "浪漫", "高口碑"],
    synopsis:
      "在宇宙边缘的最后一间旅馆，疲惫的旅人可以寄存一段不愿再想起的记忆。当新来的住客试图赎回自己遗忘的往事，老板娘却发现，那段记忆里藏着旅馆存在的全部秘密。",
  },
  {
    id: "niliu-zhicheng",
    title: "逆流之城",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%2C%20rain%20soaked%20city%20alley%20at%20night%20with%20a%20lone%20detective%20silhouette%2C%20cold%20blue%20gray%20with%20orange%20streetlight%2C%20noir%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-09&orientation=portrait",
    year: 2022,
    region: "欧美",
    genres: ["悬疑", "犯罪"],
    director: "Marcus Vale",
    cast: ["Owen Blake", "Sofia Lund", "Dean Russo"],
    duration: "130分钟",
    language: "英语",
    rating: 8.0,
    popularity: 82,
    tags: ["犯罪", "悬疑", "冷硬"],
    synopsis:
      "这座城市依靠一条逆流的河而建造，也依靠一条不成文的规矩而运转。当一名固执的侦探决定动那条规矩，整座城市的暗流都被搅动起来。",
  },
  {
    id: "yiwan-retang",
    title: "一碗热汤",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20warm%20family%20comedy%20movie%20poster%2C%20steaming%20bowl%20of%20soup%20on%20a%20family%20dining%20table%2C%20cozy%20amber%20light%2C%20heartwarming%20mood%2C%20soft%20shallow%20depth%20of%20field%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-10&orientation=portrait",
    year: 2024,
    region: "大陆",
    genres: ["喜剧", "家庭"],
    director: "吴大鹏",
    cast: ["刘慧兰", "孙建国", "米粒"],
    duration: "98分钟",
    language: "普通话",
    rating: 8.1,
    popularity: 85,
    tags: ["合家欢", "治愈", "轻松"],
    synopsis:
      "一家开了三十年的小餐馆面临拆迁，老板一家为要不要继续吵得不可开交。一场突如其来的家庭聚会，让所有人都重新想明白了一件事：能坐在一起喝碗热汤，就是天大的福气。",
  },
  {
    id: "yuji-buzailai",
    title: "雨季不再来",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20youth%20arthouse%20movie%20poster%2C%20a%20girl%20holding%20an%20umbrella%20on%20an%20empty%20school%20field%20in%20the%20rain%2C%20muted%20rose%20and%20gray%20tone%2C%20melancholic%20nostalgic%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-11&orientation=portrait",
    year: 2019,
    region: "港台",
    genres: ["青春", "文艺"],
    director: "黄立晴",
    cast: ["简宁", "游以晴"],
    duration: "106分钟",
    language: "普通话",
    rating: 7.8,
    popularity: 64,
    tags: ["青春", "文艺", "怀旧"],
    synopsis:
      "高中最后一个雨季，两个女孩在空荡的操场上约定彼此都不会忘记。多年后重逢，她们才发现，有些诺言兑现的方式，和想象中完全不同。",
  },
  {
    id: "miwu-dangan",
    title: "迷雾档案",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20movie%20poster%2C%20an%20old%20case%20file%20folder%20under%20dim%20desk%20lamp%2C%20fog%20in%20moonlight%20outside%20a%20window%2C%20cold%20atmospheric%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-12&orientation=portrait",
    year: 2023,
    region: "欧美",
    genres: ["悬疑", "惊悚"],
    director: "Helena Frost",
    cast: ["Clara Nolan", "Victor Adeyemi"],
    duration: "120分钟",
    language: "英语",
    rating: 7.7,
    popularity: 74,
    tags: ["悬疑", "惊悚", "反转"],
    synopsis:
      "一份被封存二十年的旧案卷宗，被一位年轻档案管理员无意间重新打开。随着拼图逐渐完整，她开始怀疑，自己要找的凶手或许一直就坐在隔壁的办公室。",
  },
  {
    id: "chunshan-kewang",
    title: "春山可望",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20arthouse%20drama%20movie%20poster%2C%20misty%20green%20mountains%20at%20dawn%20with%20a%20small%20village%20below%2C%20soft%20peach%20sunrise%20glow%2C%20poetic%20serene%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-13&orientation=portrait",
    year: 2022,
    region: "大陆",
    genres: ["剧情", "文艺"],
    director: "高原",
    cast: ["秦望", "叶知秋", "老周"],
    duration: "124分钟",
    language: "普通话",
    rating: 8.2,
    popularity: 71,
    tags: ["文艺", "人文", "高口碑"],
    synopsis:
      "一位年轻的乡村教师，在群山环抱的村小里守着十几个孩子和一座漏雨的教室。春天到来的时候，他决定带着孩子们翻过那座山，去看一看山那边的世界。",
  },
  {
    id: "motianlun-gaobai",
    title: "摩天轮下的告白",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20comedy%20movie%20poster%2C%20illuminated%20ferris%20wheel%20at%20night%20with%20two%20figures%2C%20warm%20orange%20and%20pink%20lights%2C%20playful%20date%20night%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-14&orientation=portrait",
    year: 2024,
    region: "日韩",
    genres: ["爱情", "喜剧"],
    director: "金河允",
    cast: ["李诗恩", "姜道贤"],
    duration: "102分钟",
    language: "韩语",
    rating: 8.0,
    popularity: 87,
    tags: ["甜宠", "轻松", "热映"],
    synopsis:
      "游乐园的摩天轮即将停运，一位笨拙的摄影师决定在那里完成他酝酿了三年的告白。可当天晚上，所有精心准备的计划全都乱了套。一场关于勇气与心动的浪漫喜剧。",
  },
  {
    id: "zuihou-yiban-ditie",
    title: "最后一班地铁",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%2C%20empty%20subway%20carriage%20at%20midnight%20with%20warm%20interior%20lights%2C%20a%20lone%20passenger%2C%20quiet%20introspective%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-15&orientation=portrait",
    year: 2021,
    region: "大陆",
    genres: ["剧情", "悬疑"],
    director: "黎远",
    cast: ["程亦", "白露", "徐岚"],
    duration: "112分钟",
    language: "普通话",
    rating: 7.9,
    popularity: 69,
    tags: ["都市", "悬疑", "人文"],
    synopsis:
      "深夜的最后一班地铁上，五个陌生人在同一节车厢里，各自揣着一个不愿被人知道的秘密。当列车抵达终点，他们的人生已经悄然交汇。",
  },
  {
    id: "baizhou-yanhuo",
    title: "白昼焰火",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20action%20crime%20movie%20poster%2C%20two%20rivals%20facing%20off%20on%20a%20rooftop%20at%20dusk%2C%20orange%20fireworks%20in%20daylight%20sky%2C%20tension%20filled%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-16&orientation=portrait",
    year: 2023,
    region: "港台",
    genres: ["动作", "犯罪"],
    director: "杜铭",
    cast: ["张家豪", "文咏诗", "林子锋"],
    duration: "126分钟",
    language: "粤语",
    rating: 7.8,
    popularity: 80,
    tags: ["警匪", "动作", "紧张"],
    synopsis:
      "一对曾经情同手足的搭档，如今站在了法律的两端。城市上空绽放的白昼焰火，见证着他们最后一次的正面交锋，也见证着一段兄弟情义的终结。",
  },
  {
    id: "zhishang-huayuan",
    title: "纸上花园",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20animated%20fantasy%20movie%20poster%2C%20a%20paper%20world%20with%20blooming%20flowers%20folding%20into%20shape%2C%20soft%20pastel%20pink%20and%20cream%20tone%2C%20whimsical%20dreamlike%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-17&orientation=portrait",
    year: 2024,
    region: "日韩",
    genres: ["动画", "奇幻"],
    director: "新海绘里",
    cast: ["花泽实", "浅野悠"],
    duration: "96分钟",
    language: "日语",
    rating: 8.7,
    popularity: 92,
    tags: ["动画", "奇幻", "治愈"],
    featured: true,
    synopsis:
      "在一座由纸张折成的城市里，少女靠折纸培育出会开花的植物。为了拯救逐渐褪色的家园，她踏上旅程，去寻找那朵只存在于传说中的七彩之花。一部献给想象力的治愈动画。",
  },
  {
    id: "guitou-wanli",
    title: "归途万里",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20drama%20movie%20poster%2C%20a%20traveler%20walking%20across%20vast%20golden%20grassland%20under%20a%20wide%20sky%2C%20warm%20amber%20and%20peach%20tones%2C%20epic%20serene%20journey%20mood%2C%20vertical%20poster%20art%20no%20text&width=600&height=900&seq=movie-poster-18&orientation=portrait",
    year: 2022,
    region: "大陆",
    genres: ["剧情", "冒险"],
    director: "格日勒",
    cast: ["巴特尔", "乌兰", "陈默"],
    duration: "132分钟",
    language: "普通话",
    rating: 8.3,
    popularity: 76,
    tags: ["公路", "冒险", "人文"],
    synopsis:
      "一位年迈的牧民牵着骆驼，踏上横跨千里草原的归乡之路，只为回到儿时的那片牧场。一路上他遇见了形形色色的人，也慢慢放下了背负半生的执念。",
  },
];